import { render, staticRenderFns } from "./photoAdd.vue?vue&type=template&id=2987f0c5&scoped=true&"
import script from "./photoAdd.vue?vue&type=script&lang=js&"
export * from "./photoAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2987f0c5",
  null
  
)

export default component.exports